import { SVGProps, Ref, forwardRef } from 'react';

export const SendWebOutlinedSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M30.126 30.072c-1.305 1.265-4.038.378-9.504-1.396l-1.946-.631c-1.324-.43-1.987-.645-2.676-.645s-1.352.215-2.676.645l-1.946.631c-5.466 1.774-8.199 2.66-9.504 1.396-1.305-1.266-.126-3.659 2.234-8.444l6.588-13.362C12.974 3.644 14.114 1.333 16 1.333s3.025 2.311 5.304 6.933l6.588 13.362c2.36 4.785 3.54 7.178 2.234 8.444M12.848 9.327 6.261 22.69c-1.22 2.472-1.998 4.067-2.355 5.202q-.068.218-.106.372c.19-.01.458-.04.826-.109 1.338-.25 3.209-.851 6.011-1.76l2.381-.774L16 12.504l2.98 13.116 2.382.773c2.803.91 4.673 1.511 6.012 1.761.368.069.635.098.826.108a6 6 0 0 0-.106-.371c-.358-1.135-1.136-2.73-2.355-5.202L19.152 9.327c-1.177-2.386-1.94-3.918-2.616-4.888-.253-.363-.429-.552-.536-.648-.107.096-.283.285-.536.648-.676.97-1.44 2.502-2.616 4.888"
                fill="currentColor"
            />
        </g>
    </svg>
));
SendWebOutlinedSize32Glyph.displayName = 'SendWebOutlinedSize32Glyph';
